import observeCounter from '../../service/observer';

export default function ITextPages() {
  observeCounter();
}
